import { COLORS } from 'constants/index';

const MuiCardContent = {
  root: {
    backgroundColor: COLORS.WHITE,
    padding: '16px',
    '&:last-child': {
      paddingBottom: '',
    }
  }
};

export default MuiCardContent;